module.exports = __webpack_public_path__ + "static/media/azet-logo-horizontal-white.e208227d.png";